import { Button, ButtonProps } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { ClickAbsorber } from './ClickAbsorber';

export interface ButtonLinkProps extends Omit<ButtonProps, 'component' | 'href'> {
  readonly to: string;
  readonly openInNewTab?: boolean;
  readonly target?: string;
}

/**
 * MUI Button component that acts as a link using React Router
 * This component prevents the double navigation issue that can occur with nested click handlers
 */
export const ButtonLink: React.FC<ButtonLinkProps> = ({
  to,
  openInNewTab = false,
  target,
  children,
  ...rest
}) => {
  const linkTarget = openInNewTab ? '_blank' : target;

  return (
    <ClickAbsorber preventDefault={false}>
      <Button component={Link as any} size="small" to={to} target={linkTarget} {...rest}>
        {children}
      </Button>
    </ClickAbsorber>
  );
};
